export const errCodes = {
  Unauthorized: {
    title: "Unauthorized Access",
    message:
      "We apologize for the inconvenience, but you are not authorized to access this site. Please contact the admnistrator.",
  },
  Internal: {
    title: "Internal Server Error",
    message: "The server encountered an internal error or misconfiguration and was unable to complete your request."
  },
  NotFound: {
    title: "",
    message: ""
  }
};
